export const setStore = (key, data) => {
  sessionStorage.setItem(key, JSON.stringify(data))
}

export const removeStore = key => {
  sessionStorage.removeItem(key)
}
